// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48b87ff7","874":"cb2ce7ac"}[chunkId] + ".chunk.js";
};